module.exports = __webpack_public_path__ + "images/32fccfc9c453e92ce477a4308eac2557-embed.png";